<template>
    <div class="filter-panel">
        <MobileFilters
            v-if="isMobileView"
            class="filter-panel__filters -wrap filter-panel__mobile-filters"
            :class="classes"
            :style="styles"
            ref="filters"
            type="reporting"
        />
        <DesktopFilters v-if="isDesktopView"
            class="filter-panel__filters -wrap"
            :class="classes"
            :style="styles"
            ref="filters"
            type="reporting"
        />
        <TotemOverlay v-show="showFiltersOverlay" @click="hideMoreFilters"  shouldCoverSidebar/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import debounce from 'components/shared/mixins/debounce'
    import ExpandSearch from 'components/searchable-listing/filters-elements/ExpandSearch'
    import MobileFilters from 'components/user/organizationreport/filters/MobileFilters'
    import DesktopFilters from 'components/user/organizationreport/filters/DesktopFilters'

    export default {
        name: 'ReportingFilters',
        components: {
            DesktopFilters,
            MobileFilters,
            ExpandSearch
        },
        mixins: [
            debounce
        ],
        data () {
            return {
                filterPanelSelectsHeight: null,
                shouldStartFilterTransitions: false,
            }
        },
        computed: {
            ...mapGetters({
                showMoreFilters: 'CourseFilter/getShowMoreFilterState'
            }),
            classes () {
                return [
                    { 'show-filters': this.showMoreFilters },
                    { 'start-transitions': this.shouldStartFilterTransitions }
                ]
            },
            styles () {
                return { marginTop: -this.filterSelectsHeight + 'px' }
            },
            showFiltersOverlay () {
                return this.isMobileView && this.showMoreFilters
            },
            filterSelectsHeight () {
                if (this.isMobileView) {
                    return 0
                }
                return this.showMoreFilters ? 0 : this.filterPanelSelectsHeight + 30
            }
        },
        methods: {
            getFilterSelectsHeight () {
                const panel = this.$refs?.filters.getFilterPanelSelects()
                if (panel) {
                    this.filterPanelSelectsHeight = panel
                }
            },
            hideMoreFilters () {
                this.$store.dispatch('CourseFilter/showMoreFilters', false)
            }
        },
        watch: {
            showMoreFilters: {
                handler () {
                    this.shouldStartFilterTransitions = true
                    setTimeout(() => {
                        this.shouldStartFilterTransitions = false
                    }, 400)
                }
            }
        },
        beforeDestroy () {
            if (this.$route.name !== 'course-list-course-page') {
                this.$store.dispatch('CourseFilter/clearFilter')
            }
        }
    }
</script>

<style scoped lang="scss">
    .filter-panel {
        display: flex;
        flex-direction: column;
        background: $ghost_white;
        padding: 20px;

        &__filters {
            padding: 10px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            position: relative;
            z-index: 15;
            transition: none;

            &.show-filters {
                margin-top: 0;
            }

            &.start-transitions {
                transition: margin-top 0.3s ease-in-out;
            }
        }

        &__mobile-filters {
            position: fixed;
            top: 0;
            bottom: 0;
            display: block;
            background: $white;
            z-index: 1000;
            width: 300px;
            right: -300px;
            transition: none;
            margin: 0;
            padding: 70px 20px 20px;

            &.show-filters {
                right: 0;
                margin: 0;
            }

            &.start-transitions {
                transition: right 0.3s ease-in-out;
            }
        }

        &__selects {
            display: flex;
            flex-direction: row;
            flex: 1;
            flex-wrap: wrap;
            justify-content: flex-start;
        }

        &__label {
            display: inline-block;
            margin: 20px 0;

            [class*="desktop"] & {
                margin: 8px 20px 0 0;
            }
        }

        &__result {
            background: $white;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            padding: 20px 0 30px;

            [class*="desktop"] & {
                background: $white;
                flex-direction: row;

            }
        }

        &__sort-toggle {
            display: flex;
            width: 100%;
            justify-content: space-between;
        }
        .icon-clear {
            font-size: 2.4rem;
            color: $carnation;
            margin: 10px 0;

            [class*="desktop"] & {
                margin: 6px 0 0 10px;
            }
        }

        .icon-info {
            font-size: 2rem;
            margin: 0 15px 0 0;
        }
    }
</style>
